// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__YbDzY","gfeWrapper":"CalendarEvent_gfeWrapper__29Aj9"};